function initSweepsIframe() {
  var iframe = document.getElementById("sweepsiframe");
  if (iframe) {
    iframe.setAttribute("scrolling", "no");

    var script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "https://cdn.dja.com/js/iframe.js";
    iframe.insertAdjacentElement("afterend", script);
  }
}

if (document.readyState !== "loading") {
  initSweepsIframe();
} else {
  document.addEventListener("DOMContentLoaded", initSweepsIframe);
}
